module.exports = __webpack_public_path__ + "ddd0143b45afe504e0bd1346d9145c0c.png";